<template>
    <div class="subscribe-btn lr-img-scale"
         :class="{'lottie-wrap-hide': hideCollectSuccessAnim }"
         @mouseenter="startAnimation"
         @mouseleave="stopAnimation"
    >
        <div class="lottie-wrap">
            <lottie v-show="!isCollection"
                    :options="bellOptions"
                    :height="24"
                    :width="24"
                    @animCreated="collectAnimationCeratedHandler"
            />
            <lottie v-show="isCollection"
                    :options="bellSuccessOptions"
                    :height="24"
                    :width="24"
                    @animCreated="collectSuccessAnimationCeratedHandler"
            />
        </div>
        <p>{{ langTransfer(isCollection && hideCollectSuccessAnim?'已订阅':'订阅') }}</p>
    </div>
</template>

<script>
    import * as animationDataBell from '@/assets/lottie-json/bell.json'
    import * as animationDataBellSuccess from '@/assets/lottie-json/bellsuccess.json'

    export default {
        name: 'LottieSubscribeBtn',
        props: {
            isCollection: {
                type: Boolean,
                default: undefined
            }
        },
        data () {
            return {
                bellOptions: {
                    animationData: animationDataBell.default,
                    loop: false,
                    autoplay: false
                },
                bellSuccessOptions: {
                    animationData: animationDataBellSuccess.default,
                    loop: false,
                    autoplay: false
                },
                collectAnim: undefined,
                collectSuccessAnim: undefined,
                hideCollectSuccessAnim: false
            }
        },
        watch: {
            isCollection: {
                immediate: true,
                handler (newVal, oldVal) {
                    if (!this.collectSuccessAnim) {
                        return
                    }
                    if (newVal) {
                        if (typeof oldVal === 'undefined') {
                            this.hideCollectSuccessAnim = true
                            return
                        }
                        this.collectSuccessAnim.play()
                    } else {
                        this.collectSuccessAnim.stop()
                        this.hideCollectSuccessAnim = false
                    }
                }
            }
        },
        created () {
        },
        mounted () {
        },
        methods: {
            collectAnimationCeratedHandler (anim) {
                this.collectAnim = anim
            },
            collectSuccessAnimationCeratedHandler (anim) {
                this.collectSuccessAnim = anim
                this.collectSuccessAnim.addEventListener('complete', () => {
                    setTimeout(() => {
                        this.hideCollectSuccessAnim = true
                    }, 300)
                })
            },
            startAnimation () {
                if (this.isCollection) {
                    return
                }
                this.collectAnim.play()
            },
            stopAnimation () {
                if (this.isCollection) {
                    return
                }
                this.collectAnim.stop()
            }
        }
    }
</script>

<style scoped lang="less">

    .subscribe-btn {
        width: 260px;
        height: 48px;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #FFFFFF;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
        user-select: none;

        .lottie-wrap {
            width: 24px;
            overflow: hidden;
            margin-left: 98px;
            margin-right: 4px;

            div {
                margin: 0 !important;
            }

        }
    }

    .lottie-wrap-hide {
        background: #606266;

        .lottie-wrap {
            width: 0;
            transition: width .4s;
            margin-right: 10px;
        }
    }
</style>
